import { useParams } from 'react-router-dom';
import { clsx } from 'clsx';
import React, { useEffect, useState } from 'react';
import { OnboardingHeadSteps } from 'src/pages/OnboardingPage/OnboardingHead/OnboardingHeadSteps';
import {
  OnboardingHeadConstants,
  OnboardingHeadConstantsManualSystemPompt,
} from 'src/pages/OnboardingPage/OnboardingHead/OnboardingHeadConstants';
import { useAppSelector } from 'src/store';

export const OnboardingHead = () => {
  const { step } = useParams();
  const stepNumber = (step && +step) || 0;
  const { promptType } = useAppSelector((s) => s.onboardingSlice);
  const [title, setTitle] = useState<React.ReactNode>('');
  const [description, setDescription] = useState<React.ReactNode>('');

  useEffect(() => {
    if (step === '4' && promptType === 'manual') {
      setTitle(OnboardingHeadConstantsManualSystemPompt.title);
      setDescription(OnboardingHeadConstantsManualSystemPompt.description);
    } else {
      setTitle(OnboardingHeadConstants[stepNumber]?.title);
      setDescription(OnboardingHeadConstants[stepNumber]?.description);
    }
  }, [step, promptType]);

  return (
    <div className={'flex flex-col w-full items-center max-w-[600px] gap-14'}>
      <div className={clsx('flex flex-row gap-1.5 py-3', !stepNumber && 'invisible')}>
        <OnboardingHeadSteps step={stepNumber} />
      </div>
      <div className={'flex flex-col gap-1.5'}>
        <h1 className={'font-jamjuree uppercase text-[1.375rem] font-bold text-black text-center'}>
          {title}
        </h1>
        <p className={'font-jamjuree text-ebony_opacity_50 text-center font-medium'}>
          {description}
        </p>
      </div>
    </div>
  );
};
